import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconSize, IconType } from '../components/atoms/icon/icon';

export default {
  title: 'Current Month Totals',
  attributeName: 'current-month-view',
  fields: [
    {
      attributeName: 'month',
      type: FormInputTypes.TEXT,
      placeholder: 'Actual Month',
      label: 'Actual Month',
      errorText: '',
      canEdit:false,
    },
    {
      attributeName: 'year',
      type: FormInputTypes.TEXT,
      label: 'Actual year',
      errorText: '',
      canEdit:false,
    },
    {
      attributeName: 'amount',
      type: FormInputTypes.TEXT,
      label: 'Actual Month Total Amount',
      errorText: '',
      canEdit:false,
    },
    {
      attributeName: 'revenue',
      type: FormInputTypes.TEXT,
      label: 'Actual Month Revenue',
      errorText: '',
      canEdit:false,
    },
    {
      attributeName: 'ticketsSold',
      type: FormInputTypes.TEXT,
      label: 'Ticket sold',
      errorText: '',
      canEdit:false,
    },
    {
      attributeName: 'ticketsReturned',
      type: FormInputTypes.TEXT,
      label: 'Tickets Returned',
      errorText: '',
      canEdit:false,
    },
    {
      attributeName: 'viewTickets',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      label: 'View Transactions',      
      iconSize: IconSize.DOUBLE,
      errorText: '',
      canEdit:false,
    },
  ],
};
